import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { bookingsAPI } from 'api/bookingsAPI'
import axios from 'axios'

export const amendBooking: any = createAsyncThunk(
  'bookings/amendBooking',
  async ({ bookingId, amendData }: any, { rejectWithValue }) => {
    try {
      const response = await bookingsAPI.updateBooking(bookingId, amendData)
      // response.roles = ['Traveller']
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

//Store Defaults
const accountReferencesDefault = {
  clientAccountNumber: null,
  bookerId: null,
  isBookingOnBehalfOf: false,
  onBehalfOf: null,
  bookingReferenceValues: null,
}
const travellerInfoDefault = { passengers: null, numberOfPassengers: 1 }
const jyrneyInfoDefault = {
  journeyTypeName: 'OneWay',
  additionalStops: [],
  isImmediateJourney: false,
}

const bookingsSlice = createSlice({
  name: 'bookings',
  initialState: {
    quickQuote: false,
    cancelSuccess: false,
    copyBooking: null,
    newBooking: null,
    newBookingPreview: null,
    newQuotedBooking: null,
    bookingClient: null,
    bookingClientUsers: null,
    accountReferences: accountReferencesDefault,
    travellerInfo: travellerInfoDefault,
    journeyInfo: jyrneyInfoDefault,
    transportInfo: {
      transport: 'default',
    },
  },
  reducers: {
    copyBooking(state: any, action) {
      const newState = action.payload
      state.copyBooking = newState
    },
    setQuickQuote(state: any, action) {
      const newState = action.payload
      state.quickQuote = newState
    },
    setCancelSuccess(state: any, action) {
      const newState = action.payload
      state.cancelSuccess = newState
    },
    createBooking(state: any, action) {
      const newState = {
        ...state.newBooking,
        ...action.payload,
      }
      state.newBooking = newState
    },
    createBookingPreview(state: any, action) {
      const newState = {
        ...state.newBookingPreview,
        ...action.payload,
      }
      state.newBookingPreview = newState
    },
    createQuotedBooking(state: any, action) {
      const updatedVehicles = action.payload.outbound.vehicles.map(
        (item: any) => {
          const updatedVehicle = {
            supplierQuoteReference: item.supplierQuoteReference,
            quantity: item.quantity,
          }
          return updatedVehicle
        },
      )

      const newState = {
        outbound: {
          quoteReference: action.payload.outbound.quoteReference,
          vehicles: updatedVehicles,
        },
      }
      state.newQuotedBooking = newState
    },
    createUsersArray(state: any, action) {
      const newState = {
        ...action.payload,
      }
      state.usersArray = newState
    },
    resetBooking(state: any) {
      state.newBooking = null
      state.newBookingPreview = null
      state.newQuotedBooking = null
      state.accountReferences = accountReferencesDefault
      state.travellerInfo = travellerInfoDefault
      state.journeyInfo = jyrneyInfoDefault
      state.bookingClient = null
      state.bookingClientUsers = null
    },
    setAccountReferences(state: any, action) {
      const newState = {
        clientAccountNumber: action.payload.bookingClient.accountNumber,
        bookerId: action.payload.bookerId,
        isBookingOnBehalfOf: action.payload.isBookingOnBehalfOf,
        onBehalfOf: action.payload.onBehalfOf,
        bookingReferenceValues: action.payload.bookingReferenceValues,
      }
      state.accountReferences = newState

      //Update Global State
      state.bookingClient = action.payload.bookingClient
      state.bookingClientUsers = action.payload.bookingClientUsers

      //update booking
      const newBookingEntry = {
        ...state.newBooking,
        bookerId: action.payload.bookerId,
        clientAccountNumber: action.payload.bookingClient.accountNumber,
        onBehalfOf: action.payload.onBehalfOf,
        bookingReferences: action.payload.bookingReferenceValues,
      }
      state.newBooking = newBookingEntry

      //update booking preview
      const bookingPreviewUpdate = {
        ...state.newBookingPreview,
        companyName: action.payload.bookingClient.companyName,
      }
      state.newBookingPreview = bookingPreviewUpdate
    },
    setTravellerInfo(state: any, action) {
      const newState = {
        ...state.travellerInfo,
        ...action.payload,
      }
      state.travellerInfo = newState

      //update booking
      const newBookingEntry = {
        ...state.newBooking,
        passengers: action.payload.passengers,
        numberOfPassengers: action.payload.numberOfPassengers,
      }
      state.newBooking = newBookingEntry

      //update booking preview
      const bookingPreviewUpdate = {
        ...state.newBookingPreview,
        passengers: action.payload.passengers,
      }
      state.newBookingPreview = bookingPreviewUpdate
    },
    setJourneyInfo(state: any, action) {
      const newState = {
        ...state.journeyInfo,
        ...action.payload,
      }
      state.journeyInfo = newState

      //update booking
      const newBookingEntry = {
        ...state.newBooking,
        isImmediateJourney: false, //needs updating for Ride Hail
        outbound: {
          when: action.payload.outbound.when,
          pickup: action.payload.outbound.pickup,
          dropOff: action.payload.outbound.dropOff,
          additionalStops: action.payload.outbound.additionalStops,
          specialInstructions: action.payload.outbound.specialInstructions,
          services: action.payload.outbound.services,
        },
        // inbound: {
        //     when: action.payload.inbound.when,
        //     pickup: action.payload.inbound.pickup,
        //     dropOff: action.payload.inbound.dropOff,
        //     additionalStops: action.payload.inbound.additionalStops,
        //     specialInstructions: action.payload.inbound.specialInstructions,
        //     services: action.payload.inbound.services
        // },
        journeyTypeName: action.payload.journeyTypeName,
      }
      state.newBooking = newBookingEntry
    },
    setBookingReferences(state: any, action) {
      const newState = {
        ...action.payload,
      }
      state.accountReferences = newState
    },
    setTransportInfo(state, action) {
      const newState = {
        ...action.payload,
      }
      state.transportInfo = newState
    },
  },
})

export const {
  copyBooking,
  createBooking,
  setQuickQuote,
  setCancelSuccess,
  createBookingPreview,
  createQuotedBooking,
  resetBooking,
  setBookingReferences,
  setAccountReferences,
  setTravellerInfo,
  createUsersArray,
  setJourneyInfo,
  setTransportInfo,
} = bookingsSlice.actions

export default bookingsSlice.reducer
